/* Max file size has been arbitrarily set to 26 MB, well below 
the supported max of 150 MB the twilio client can support */
export const MAX_FILE_SIZE = 26000000
